import { type GlobalEventTarget } from '@pkg/types';

export enum KeyPressEventType {
    Down = 'keydown',
    Press = 'keypress',
    Up = 'keyup',
}

export type KeyPressCallback = (event: KeyboardEvent) => void;
export type KeyPressInput = string[];

export interface KeyPressHookOptions {
    eventType?: KeyPressEventType;
    target?: GlobalEventTarget;
    disabled?: boolean;
}
